import Lenis from '@studio-freight/lenis'

// Safariでは無効化
function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

if (!isSafari()) {
  const lenis = new Lenis({
    // スクロールを制御しない要素を指定
    ignore: (el) => el.hasAttribute('data-lenis-ignore')
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  // DOMの変更を監視して、Lenisのサイズを再計算する
  // ResizeObserverを使用して、bodyのサイズ変更を検知する（アコーディオンのアニメーション等に対応）
  const resizeObserver = new ResizeObserver(() => {
    lenis.resize();
  });

  resizeObserver.observe(document.body);

  // 念のためMutationObserverも残すが、ResizeObserverでカバーできる範囲が広い
  const observer = new MutationObserver(() => {
    lenis.resize();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // toggleイベントも念のため残すが、ResizeObserverが効くはず
  document.addEventListener('toggle', () => {
    // アニメーション完了後にもリサイズが必要かもしれないので、少し遅らせて実行するか、ResizeObserverに任せる
    // ResizeObserverがあれば、アニメーション中のサイズ変更も検知される可能性があるが、
    // アニメーション終了時の最終サイズを確実に取るためにtoggleも有効。
    requestAnimationFrame(() => {
      lenis.resize();
    });
  }, true);

  // アンカーリンクのスムーススクロール対応
  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;

    // targetが_blankの場合は無視
    if (anchor.target === '_blank') return;

    e.preventDefault();
    const href = anchor.getAttribute('href');

    if (href === '#' || href === '') {
      lenis.scrollTo(0);
      return;
    }

    try {
      const target = document.querySelector(href);
      if (target) {
        lenis.scrollTo(target);
      }
    } catch (error) {
      // ignore
    }
  });
}

document.querySelectorAll('[data-lenis-ignore]').forEach((el) => {
  el.addEventListener('wheel', (e) => e.stopPropagation(), { passive: false });
});
